import { Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ValidationProblem } from 'reg-hub-common';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-batch-errors-popup',
    templateUrl: './batch-errors-popup.component.html',
    styleUrl: './batch-errors-popup.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BatchErrorsPopupComponent implements OnInit, OnDestroy {
  errors!: string | ValidationProblem[];
  rawErrors?: string;
  parsedErrors?: ValidationProblem[];

  private onDestroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: string) {
    this.errors = data;
  }

  ngOnInit(): void {
    this.rawErrors = (typeof(this.errors) == "string") ? this.errors : undefined;
    this.parsedErrors = (typeof(this.errors) != "string") ? this.errors : undefined;
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}